import { useEffect, useState } from 'react';

export const useMediaQuery = (query: string): boolean => {
  const [matches, setMatches] = useState(window?.matchMedia?.(query)?.matches);

  useEffect(() => {
    const media = window?.matchMedia?.(query);
    if (media?.matches !== matches) {
      setMatches(media?.matches);
    }

    const listener = () => {
      setMatches(media?.matches);
    };

    media?.addEventListener('change', listener);
    return () => media?.removeEventListener('change', listener);
  }, [matches, query]);

  return matches;
};
